import { render, staticRenderFns } from "./IntegrationSourcesField.vue?vue&type=template&id=8bd2c154&"
import script from "./IntegrationSourcesField.vue?vue&type=script&lang=js&"
export * from "./IntegrationSourcesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VChip,VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bd2c154')) {
      api.createRecord('8bd2c154', component.options)
    } else {
      api.reload('8bd2c154', component.options)
    }
    module.hot.accept("./IntegrationSourcesField.vue?vue&type=template&id=8bd2c154&", function () {
      api.rerender('8bd2c154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Vehicles/Forms/HelperFields/IntegrationSourcesField.vue"
export default component.exports